/** Plain-words text for an active accounts filter, shown as a chip above the table. */
import type { Identifier } from "ra-core";

import { ACCOUNT_STATUSES } from "../providers/zinspector/crmConfig";

const FIELD_LABELS: Record<string, string> = {
  name: "Name",
  status: "Status",
  market: "Market",
  account_kind: "Account kind",
  health: "Health",
  doors_total: "Doors",
  doors_share: "Share of doors",
  account_manager_id: "Account manager",
  main_contact_name: "Main contact",
  accounting_id: "FileMaker ID",
  lead_source: "Lead source",
  pm_software: "PM software",
  next_step: "Next step",
  next_step_due: "Next step due",
  last_touch: "Last touch",
  open_deals: "Open deals",
  open_tickets: "Open tickets",
  days_since_signed: "Days since signing",
};

const statusLabel = (id: unknown) =>
  ACCOUNT_STATUSES.find((s) => s.id === id)?.label ?? String(id);

const label = (field: string) => FIELD_LABELS[field] ?? field;

export const describeFilter = (
  key: string,
  value: unknown,
  identityId?: Identifier,
): string => {
  if (key === "needs_info") return value ? "Needs info" : "Complete info";
  if (key === "is_untouched") {
    return value ? "Never worked on" : "Being worked";
  }
  if (key === "account_manager_id" && value === identityId) {
    return "My accounts";
  }
  if (key.endsWith("_q")) {
    return `${label(key.slice(0, -2))} contains "${String(value)}"`;
  }
  const [field, operator] = key.split("@");
  if (operator === "gte" || operator === "gt") {
    return field === "last_touch" || field === "next_step_due"
      ? `${label(field)} since ${String(value)}`
      : `${label(field)} ≥ ${String(value)}`;
  }
  if (operator === "lte" || operator === "lt") {
    return field === "last_touch" || field === "next_step_due"
      ? `${label(field)} before ${String(value)}`
      : `${label(field)} ≤ ${String(value)}`;
  }
  if (Array.isArray(value)) {
    const values = field === "status" ? value.map(statusLabel) : value;
    return `${label(field)}: ${values.join(", ")}`;
  }
  if (value === "" || value === null) return `No ${label(field).toLowerCase()}`;
  return `${label(field)}: ${String(value)}`;
};
